export const PopupEnding = ({ onClose }) => {
  const { t } = useTranslation();

  // const setPopup = useAppStore((state) => state.setPopup);
  // const _onClose = useCallback(() => {
  //   setPopup(null);
  //   onClose();
  // }, [onClose]);

  return (
    <Popup
      popupId="ending"
      className="frame-brown font-gellix text-[1.8rem] leading-[1.18] font-semibold tracking-[0.02em]"
      closable={false}
      // onClose={_onClose}
    >
      <img src="/assets/images-next/beer.webp" />
      <h2 className="typo-h2 mt-2">{t('ending.heading')}</h2>

      <div className="my-3 text-center">{t('ending.desc')}</div>

      <a
        className="btn-primary"
        href={t('ending.link')}
        target="_blank"
      >
        {t('ending.cta')}
      </a>
    </Popup>
  );
};
